import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProductAttributeForm from "./productAttributeForm";
import {
  fetchProductAttributes,
  deleteProductAttribute,
  selectAllProductAttributes,
  selectFetchLoading,
  selectDeleteLoading,
} from "../../../slices/company/productAttributeSlice";
import { Pen, Delete } from "lucide-react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import { customTableStyles } from "../../../utils/tableStylings";

const ProductAttributePage = () => {
  
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedAttribute, setSelectedAttribute] = useState(null);
  const [modalHeading, setModalHeading] = useState("");
  const attributes = useSelector(selectAllProductAttributes);
  const fetchLoading = useSelector(selectFetchLoading);
  const deleteLoading = useSelector(selectDeleteLoading);

  useEffect(() => {
    const company = JSON.parse(localStorage.getItem("company"));
    if (company) {
      const companyId = company.company?.id;
      dispatch(fetchProductAttributes(companyId));
    }
  }, [dispatch]);

  const handleAdd = () => {
    setSelectedAttribute(null);
    setModalHeading("Create Product Attribute");
    setShowModal(true);
  };

  const handleEdit = (attribute) => {
    setSelectedAttribute(attribute);
    setModalHeading("Edit Product Attribute");
    setShowModal(true);
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      html: `<p>This action will <b>permanently delete</b> this Product Attribute.</p>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteProductAttribute(id));
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The Product Attribute has been deleted.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      }
    });
  };

  const columns = [
    {
      name: "#",
      cell: (row, index) => index + 1,
      width: "50px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "100px"
    },
    {
      name: "Tags",
      cell: (row) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
          {Array.isArray(row.tags) ? row.tags.join(", ") : ""}
        </div>
      ),
      sortable: false,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          {row.id !== 1 && row.id !==2 &&(<>
          <span
            className="text-warning cursor-pointer me-2"
            onClick={() => handleEdit(row)}
          >
            <Pen />
          </span>
          <span
            className="text-danger cursor-pointer"
            onClick={() => handleDelete(row.id)}
          >
            <Delete />
          </span>
          </>)}
        </>
      ),
      width: "120px",
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h3 className="text-primary mb-0">Product Attributes</h3>
              <button className="btn btn-primary" onClick={handleAdd}>
                + Add
              </button>

            </div>
            <div className="card-body">
              {fetchLoading ? (
                <p>Loading...</p>
              ) : attributes && attributes.length > 0 ? (
                <DataTable
                  columns={columns}
                  data={attributes}
                  pagination
                  highlightOnHover
                  striped
                  dense
                  customStyles={customTableStyles}
                />
              ) : (
                <p>No Data Found</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <ProductAttributeForm
        show={showModal}
        onClose={() => setShowModal(false)}
        heading={modalHeading}
        initialData={selectedAttribute}
      />
    </>
  );
};

export default ProductAttributePage;
